import { client } from '@mb/api/client';
import { endpoints } from '@mb/api/endpoints';
import type { Event } from '@mb/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  setEventData,
  setEventLoaded,
  setEventError,
  setEventsData,
  setEventsLoaded,
  setEventsError,
} from '../redux/event/eventSlice';

export interface GetEventResponse {
  status: string;
  data: Event | undefined;
  message: string | undefined;
}

export interface GetEventsResponse {
  status: string;
  events: Event[] | undefined;
  message: string | undefined;
}

export const getEvent = createAsyncThunk(
  'event/get/event',
  // @ts-expect-error // TODO: fix types
  async (eventSlug: string, thunkApi) => {
    try {
      const {
        data: { status, data, message },
      } = await client.get<GetEventResponse>(
        endpoints.eventGetEvent + eventSlug,
      );

      if (status === 'failed') {
        thunkApi.dispatch(setEventError(message));
      }

      if (data) {
        thunkApi.dispatch(setEventData(data));
      }

      thunkApi.dispatch(setEventLoaded(true));
      return {
        data,
      };
    } catch (e) {
      thunkApi.dispatch(setEventLoaded(true));
      console.log('Error getEvent:', e);
    }
  },
);

export const getEvents = createAsyncThunk(
  'events/event/getall',
  // @ts-expect-error // TODO: fix types
  async (_, thunkApi) => {
    try {
      const {
        data: { status, events, message },
      } = await client.get<GetEventsResponse>(endpoints.eventGetAll);

      if (status === 'failed') {
        thunkApi.dispatch(setEventsError(message));
      }

      if (Array.isArray(events)) {
        if (events.length > 4) events.length = 4;
        thunkApi.dispatch(setEventsData(events));
      }

      thunkApi.dispatch(setEventsLoaded(true));
      return {
        events,
      };
    } catch (e) {
      thunkApi.dispatch(setEventsLoaded(true));
      console.log('Error getEventsAll:', e);
    }
  },
);
